import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import ContratoModalVerificaCancelamento from '@/views/contratos/ContratoModalVerificaCancelamento'
import ContratoModalCancelamento from '@/views/contratos/ContratoModalCancelamento'
import ServicosDoPlano from '../Areas/ServicosDoPlano'
import SaldoServicos from '../Areas/SaldoServicos'
import PlanoAdicionais from '../Areas/PlanoAdicionais'
import CancelamentoContrato from '@/views/contratos/CancelamentoContrato.vue'
import constants from '@/util/constants'
import UpgradePlano from '@/views/contratos/UpgradePlano.vue'

export default {
  name: 'contratos',
  components: {
    cabecalho,
    ServicosDoPlano,
    PlanoAdicionais,
    SaldoServicos,
    menuLateral,
    spinnerProcessando,
    'b-toast': BToast,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    ContratoModalVerificaCancelamento,
    ContratoModalCancelamento,
    CancelamentoContrato,
    UpgradePlano
  },
  computed: {
    planoGratuitoContratado () {
      return this.resumoContrato.plano_id === constants.planos.free
    }
  },
  data: () => {
    return {
      isVencido: false,
      pedidoCancelamento: false,
      podeAbortarCancelamento: false,
      podeAlterarPlano: false,
      temFaturaEmAtrasoDoContratoPrincipal: false,
      resumoContrato: [],
      contratosAdicionais: [],
      contratosAdicionaisCredito: [],
      resumoContratoPlano: [],
      contratosAdicionaisPedido: [],
      valorTotal: 0,
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      planoUpgrade: null
    }
  },
  async mounted () {
    // Quando chegar nessa pagina redirecionar para outra
    this.$router.push({ name: 'recursos' })

    await this.obterResumoContrato()
    document.body.style.overflow = 'auto'
    this.pedidoCancelamento = localStorage.getItem('pedido_cancelamento') === 'true' ?? false
    this.podeAlterarPlano = localStorage.getItem('pode_alterar_plano') === 'true' ?? false

    if (this.resumoContrato.data_vencimento < this.$date().format('YYYY-MM-DD')) {
      this.isVencido = true
    }
    await this.obterPlanoUpgrade()
  },
  methods: {
    trocaDePlano () {
      this.$router.push({ name: 'alterar-plano-contrato' })
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor)
    },
    async abortarCancelamento (contrato, alterar_plano = '0') {
      this.definirFlagCarregandoDados(true, mensagens.cancelandoContrato)
      try {
        const retorno = await this.axios.post(`/manager/conta/contrato/abortar-cancelamento`, { contrato_id: contrato, alterar_plano: alterar_plano })
        if (retorno.data.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', retorno.data.retorno.mensagem)
          this.pedidoCancelamento = false
          await this.obterResumoContrato()
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', retorno.data.retorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCancelandoContrato)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async obterResumoContrato () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        this.valorTotal = 0
        const resposta = await this.axios.get(`/manager/conta/contratos`)
        if (resposta.data.retorno.dados.resumo !== null) {
          this.temFaturaEmAtrasoDoContratoPrincipal = resposta.data.retorno.dados.temFaturaEmAtrasoDoContratoPrincipal
          this.resumoContrato = resposta.data.retorno.dados.resumo.contrato_principal
          localStorage.setItem('pedido_cancelamento', this.resumoContrato.pedido_cancelamento)
          localStorage.setItem('pode_alterar_plano', this.resumoContrato.pode_alterar_plano)
          this.resumoContratoPlano = resposta.data.retorno.dados.resumo.contrato_principal_complementos
          this.contratosAdicionais = Object.values(resposta.data.retorno.dados.contratos_adicionais).filter(contrato => contrato.plano_tipo === 1)
          this.contratosAdicionaisCredito = Object.values(resposta.data.retorno.dados.contratos_adicionais).filter(contrato => contrato.plano_tipo === 2)
          this.contratosAdicionaisPedido = Object.values(this.contratosAdicionais).filter(contrato => contrato.pedido_cancelamento === true)
          this.pedidoCancelamento = this.resumoContrato.pedido_cancelamento
          this.podeAbortarCancelamento = this.resumoContrato.pode_abortar_cancelamento

          for (const contratoId in this.contratosAdicionais) {
            this.valorTotal += parseFloat(this.contratosAdicionais[contratoId].valor)
          }
        } else {
          this.dadosVazio = true
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async obterPlanoUpgrade () {
      if (!this.planoGratuitoContratado) {
        return
      }
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/contrato/produto/planos`)
        const planos = resposta.data.retorno.dados
        this.planoUpgrade = planos.find(plano => plano.id === constants.planos.starter && plano.contratado === false)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
